import { formatPrice, htmlDecode } from 'utils/general';

export default {
  computed: {
    hasShades() {
      return this.shadesForDropdown && this.shadesForDropdown.length;
    },
    hasSizes() {
      if (!this.product.optionNames) return false;
      return this.product.optionNames.includes('Size');
    },
    hasGWPVariants() {
      return (
        this.product.isGWP &&
        this.product.variants.find((variant) => variant.isGWPVariant)
      );
    },
    gwpVariants() {
      if (this.hasGWPVariants) {
        return this.product.variants.filter((variant) => variant.isGWPVariant);
      }
      return false;
    },
    hasAmounts() {
      if (!this.product.optionNames) return false;
      return this.product.optionNames.includes('Amount');
    },
    hasGift() {
      return typeof this.product.tags !== 'undefined' && this.product.tags
        ? this.product.tags.includes('gift card')
        : false;
    },
    isDonateProduct() {
      return typeof this.product.tags !== 'undefined' && this.product.tags
        ? this.product.tags.includes('donation')
        : false;
    },
    showSizeSelector() {
      return typeof this.product.tags !== 'undefined' && this.product.tags
        ? this.product.tags.includes('show-size-selector')
        : false;
    },
    hasSimpleVariant() {
      return this.hasSizes || this.hasAmounts;
    },
    showFilters() {
      return !['true', true].includes(
        this.product.metafields?.general?.hide_shade_range_filter,
      );
    },
  },
  methods: {
    getVariantText(variant) {
      if (this.hasGift) return formatPrice(variant.price);
      if (this.hasSizes) return htmlDecode(variant.title).split(' / ')[1];
      return htmlDecode(variant.title);
    },
    getSizeVariantText(variant) {
      return variant.title.includes(' / ')
        ? htmlDecode(variant.title).split(' / ')[1]
        : htmlDecode(variant.title);
    },
    decodeTitle(title) {
      return htmlDecode(title);
    },
  },
};
